// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "moim-" + "4754e79eda352ea7632c" + ".css";
};